
import { Database } from "@/integrations/supabase/types";

export type TestResult = {
  id: string;
  situation_id: number;
  points: number;
  index: number;
  test_date: string;
};

export type TestStatistics = {
  total_attempts: number;
  average_points: number;
  average_index: number;
  min_points: number;
  max_points: number;
  first_test_date: string;
  last_test_date: string;
};

export const approachesIndexTable = [
  { points: 5, index: 36 }, { points: 9, index: 35 }, { points: 12, index: 34 },
  { points: 14, index: 33 }, { points: 16, index: 32 }, { points: 19, index: 31 },
  { points: 22, index: 30 }, { points: 23, index: 29 }, { points: 27, index: 28 },
  { points: 29, index: 27 }, { points: 33, index: 26 }, { points: 34, index: 25 },
  { points: 37, index: 24 }, { points: 41, index: 23 }, { points: 43, index: 22 },
  { points: 46, index: 21 }, { points: 49, index: 20 }, { points: 52, index: 19 },
  { points: 56, index: 18 }, { points: 59, index: 17 }, { points: 61, index: 16 },
  { points: 66, index: 15 }, { points: 68, index: 14 }, { points: 71, index: 13 },
  { points: 74, index: 12 }, { points: 78, index: 11 }, { points: 80, index: 10 },
  { points: 84, index: 9 }, { points: 88, index: 8 }, { points: 90, index: 7 },
  { points: 94, index: 6 }, { points: 99, index: 5 }, { points: 101, index: 4 },
  { points: 106, index: 3 }, { points: 110, index: 2 }, { points: 113, index: 1 },
  { points: 117, index: 0 }, { points: 121, index: -1 }, { points: 125, index: -2 },
  { points: 127, index: -3 }, { points: 134, index: -4 }, { points: 138, index: -5 },
  { points: 143, index: -6 }, { points: 148, index: -7 }
];

export const calculateApproachIndex = (totalPoints: number): number => {
  for (let i = approachesIndexTable.length - 1; i >= 0; i--) {
    if (totalPoints >= approachesIndexTable[i].points) {
      return approachesIndexTable[i].index;
    }
  }
  return approachesIndexTable[0].index;
};
